export default __webpack_public_path__ + "static/media/kuveytturk.6450161f.png";